import { render, staticRenderFns } from "./CardSelectAndCloneElementModal.vue?vue&type=template&id=4b472acb"
import script from "./CardSelectAndCloneElementModal.vue?vue&type=script&lang=js"
export * from "./CardSelectAndCloneElementModal.vue?vue&type=script&lang=js"
import style0 from "./CardSelectAndCloneElementModal.vue?vue&type=style&index=0&id=4b472acb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports